import React, { useContext } from 'react';
import { BodyLarge, FlexColSm, FlexEnd, FlexSmAlignCenter } from 'components/Elements';
import { IconSize } from 'assets/icons/icon-sizes';
import strings from '../../strings/strings.json';
import { AuthContext } from 'contextProviders/AuthContext';
import ValidateIcon from 'assets/icons/indicators/ValidateIcon';
import { LearnerCourseContext } from 'contextProviders/LearnerCourseContext';
import Modal from './Modal';
import Button from 'components/buttons/Button';

export default function CompleteCourseModal(): JSX.Element {
    const { previewMode, setCourseState, refetchLearnerCourse, setStep } = useContext(LearnerCourseContext);
    const { userData } = useContext(AuthContext);
    const courseTitle = useContext(LearnerCourseContext).learnerCourse!.title;

    const completeCourse = async () => {
        if (previewMode) {
            setCourseState((prev) => {
                if (!prev) return prev;
                return {
                    ...prev,
                    completedDate: new Date(),
                };
            });
        } else {
            await refetchLearnerCourse();
        }

        setStep({ id: '', stepType: 'Course' });
    };

    return (
        <Modal
            headlineElement={
                <FlexColSm>
                    <BodyLarge $bold id="modal-heading">
                        {`${strings.learnerCompleteCourse.text.congratulations} ${userData.firstName}!`}
                    </BodyLarge>
                    <FlexSmAlignCenter>
                        <BodyLarge id="modal-description">{`${strings.learnerCompleteCourse.text.youHaveCompleted} ${courseTitle}`}</BodyLarge>
                        <ValidateIcon size={IconSize.MEDIUM} />
                    </FlexSmAlignCenter>
                </FlexColSm>
            }
            modalBody={
                <FlexEnd>
                    <Button
                        title={strings.learnerCompleteCourse.button.title}
                        aria={strings.learnerCompleteCourse.button.aria}
                        onClick={completeCourse}
                    />
                </FlexEnd>
            }
            onClickCloseButton={completeCourse}
        />
    );
}
